import { WizardContext } from './WizardContext';
import { useContext } from 'react';
export const WizardStep = ({ children, step }) => {
  const { activeKey } = useContext(WizardContext);
  if (activeKey !== step) return null;
  return children;
};
